







import Vue from 'vue'

export default Vue.extend({
  name: 'puzzle-space',
  props: {
    empty: {
      type: Boolean,
      default: true
    },
    locked: {
      type: Boolean,
      default: false
    },
    piece: {
      type: Number,
      default: -1
    }
  },
  data: () => {
    return {

    }
  }
})
